/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Access View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AccessView';

export const mapStateToPropsAccess = mapStateToProps;
export const mapDispatchToPropsAccess = mapDispatchToProps;

export default connect(mapStateToPropsAccess, mapDispatchToPropsAccess)(View);
